export default __webpack_public_path__ + "static/media/android.16f2347f.svg";